import styled from 'styled-components';

export const Container = styled.div``;

/* The title is the topbar's; this row holds Finish event and nothing else. */
export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s3);
  margin-bottom: var(--s5);
`;
